import GoogleLogo from '@shared/assets/avatars/GoogleLogo';
import AmazonLogo from '@shared/assets/avatars/AmazonLogo';
import InstagramLogo from '@shared/assets/avatars/InstagramLogo';
import UnityLogo from '@shared/assets/avatars/UnityLogo';
import MintegralLogo from '@shared/assets/avatars/MintegralLogo';
import TiktokLogo from '@shared/assets/avatars/TiktokLogo';
import BingLogo from '@shared/assets/avatars/BingLogo';
import McloudLogo from '@shared/assets/avatars/McloudLogo';
import BallAvatar from '@shared/assets/avatars/BallAvatar';
import BearAvatar from '@shared/assets/avatars/BearAvatar';
import KamabokoAvatar from '@shared/assets/avatars/KamabokoAvatar';
import FoxAvatar from '@shared/assets/avatars/FoxAvatar';
import PetalAvatar from '@shared/assets/avatars/PetalAvatar';
import FlowerAvatar from '@shared/assets/avatars/FlowerAvatar';
import ShieldAvatar from '@shared/assets/avatars/ShieldAvatar';
import WaveAvatar from '@shared/assets/avatars/WaveAvatar';
import LeavesAvatar from '@shared/assets/avatars/LeavesAvatar';
import MetaLogo from '@shared/assets/avatars/MetaLogo';
import DefaultAvatar from '@shared/assets/avatars/DefaultAvatar';
import FacebookLogo from '@shared/assets/avatars/FacebookLogo';
import TelegramLogo from '@shared/assets/avatars/TelegramLogo';
import TwitchLogo from '@shared/assets/avatars/TwitchLogo';

export const avatars = {
  google: <GoogleLogo />,
  amazon: <AmazonLogo />,
  instagram: <InstagramLogo />,
  unity: <UnityLogo />,
  mintegral: <MintegralLogo />,
  tiktok: <TiktokLogo />,
  bing: <BingLogo />,
  'm-cloud': <McloudLogo />,
  ball: <BallAvatar />,
  bear: <BearAvatar />,
  kamaboko: <KamabokoAvatar />,
  fox: <FoxAvatar />,
  petal: <PetalAvatar />,
  flower: <FlowerAvatar />,
  shield: <ShieldAvatar />,
  wave: <WaveAvatar />,
  leaves: <LeavesAvatar />,
  meta: <MetaLogo />,
  default: <DefaultAvatar />,
  facebook: <FacebookLogo />,
  telegram: <TelegramLogo />,
  'tg ads': <TelegramLogo />,
  twitch: <TwitchLogo />,
};

export const AVATAR_COLORS = [
  '#5BA600',
  '#E75E3C',
  '#D8B400',
  '#DE0098',
  '#4D72ED',
  '#E9933E',
  '#44ABCA',
  '#943CE7',
];
